import React from 'react';

const Navigation: React.FC = ({ children }) => (
    <div className="row">
        <div className="col-xs-12 input-row">{children}</div>
    </div>
);

export default Navigation;
